<template>
  <div>
    <router-view />
  </div>
</template>

<script>
  import { bodyClassMixin } from '@/mixins/bodyClass'
  // import MenuBar from "@/views/_globals/MenuBar"
  // import SideBar from "@/views/_globals/SideBar"

  export default {
    components: {
      // MenuBar,
      // SideBar
    },
    mixins: [ bodyClassMixin('default') ]
  }
</script>

<style lang="scss">
  @import '@/assets/scss/default';
</style>
